import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Renders an admin-editable legal page (/pages/{pageKey}), falling back to `defaults`.
export default function LegalPage({ pageKey, defaults }) {
  const { api } = useAuth();
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    api.get(`/pages/${pageKey}`)
      .then(res => {
        if (Array.isArray(res.data?.sections)) {
          setContent({
            title: res.data.title || defaults.title,
            last_updated: res.data.last_updated,
            sections: res.data.sections,
          });
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageKey]);

  return (
    <div className="min-h-screen bg-white py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#003366] mb-2">{content.title}</h1>
        {content.last_updated && (
          <p className="text-muted-foreground mb-10">Last updated: {content.last_updated}</p>
        )}

        <div className="prose prose-gray max-w-none space-y-10">
          {content.sections.map((section, i) => (
            <section key={i}>
              <h2 className="text-2xl font-semibold text-[#003366] mb-4">{i + 1}. {section.heading}</h2>
              {section.body.split(/\n\s*\n/).filter(p => p.trim()).map((para, j) => (
                <p key={j} className="text-gray-700 leading-relaxed mb-3 whitespace-pre-line">{para.trim()}</p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t">
          <Link to="/" className="text-[#003366] hover:underline font-medium">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
